var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransmissionLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2293 11.5747V9.59588H18.9004V10.9314H20.236V7.35214L15.8954 5.42671L12 2.28369L7.88203 5.60478L3.76405 7.34324V10.0411H5.09961V9.59588H7.77073V11.5747L1.98331 13.2976V16.9415H3.31887V15.6059H7.41681L5.92766 20.9481H3.54146V22.2837H20.4585V20.9481H18.0723L16.5832 15.6059H20.6811V16.9415H22.0167V13.2976L16.2293 11.5747ZM14.8937 6.47957V8.26032H9.10629V6.53745L14.8937 6.47957ZM18.9004 8.26032H16.2293V7.03606L18.9004 8.22025V8.26032ZM13.4201 5.14401H10.5799L12 3.99766L13.4201 5.14401ZM5.09961 8.26032V8.22916L7.77073 7.10283V8.26032H5.09961ZM14.8937 9.59588V11.1763L9.10629 11.154V9.59588H14.8937ZM9.10629 14.2703V12.5697H14.8937V14.2703H9.10629ZM3.39677 14.2703L7.77073 12.9682V14.2703H3.39677ZM9.70506 20.9481L12.0245 19.3165L14.3417 20.9481H9.70506ZM16.6856 20.9481L12.0245 17.6827L7.32554 20.9481L8.81469 15.6059H15.1964L16.6856 20.9481ZM16.2293 14.2703V12.9682L20.6032 14.2703H16.2293Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmissionLine);
export default __webpack_public_path__ + "static/media/transmission-line.4f641930.svg";
export { ForwardRef as ReactComponent };